import {
    getSchedule,
    generateSchedule,
    getScheduleDetailById,
    getScheduleDetailByIdForStudent,
    takeAttendanceStudent,
    takeAttendanceTeacher,
    getClassesToMainView,
    getMyClassesByMySubscription,
    generateQRToken,
    scanQRToken,
    updateSchedule as updateScheduleService,
} from '../../../services/ScheduleService';
export default {
    async loadSchedule(context, payload = false) {

        if (!payload.forceRefresh && !context.getters.shouldUpdate) return;

        const response = await getSchedule(context.rootGetters['auth/getToken'], context.rootGetters['school/getSchoolId'])
        context.commit('setSchedule', response.data.schedules);
        context.commit('setFetchTimestamp');
    },
    async generateSchedule(context, danceStyleIds) {
        const response = await generateSchedule(context.rootGetters['auth/getToken'], context.rootGetters['school/getSchoolId'], danceStyleIds)
        await context.dispatch('loadSchedule', {forceRefresh: true});
        return response.data;
    },
    async getScheduleDetailById(context, idPayload) {
        // Check if user is admin/assistant (has schoolId) or student
        const schoolId = context.rootGetters['school/getSchoolId'];
        let response;
        if (schoolId) {
            // Admin/Assistant view
            response = await getScheduleDetailById(idPayload.id, context.rootGetters['auth/getToken'], schoolId);
        } else {
            // Student view
            response = await getScheduleDetailByIdForStudent(idPayload.id, context.rootGetters['auth/getToken']);
        }
        context.commit('setScheduleDetail', response.data.schedule)
    },
    async removeSelectedSchedule({commit}) {
        commit('setScheduleDetail', null);
    },
    async takeAttendance(context, payloadSchedule) {
        await takeAttendanceStudent(context.rootGetters['school/getSchoolId'], payloadSchedule.scheduleId, payloadSchedule.subscriptionId, context.rootGetters['auth/getToken']);
        const arrFilterStudents = context.getters.getDetail.students.filter(student => student._id !== payloadSchedule.studentId);
        const student = context.getters.getDetail.students.filter(student => student._id == payloadSchedule.studentId);

        context.commit('resetStudents', arrFilterStudents);
        context.commit('resetAttendacedStudent', {
            _id: student[0]._id,
            name: student[0].student[0].name,
            email:student[0].student[0].email,
            photo: student[0].student[0].photo
        });
    },
    async takeAttendanceTeacher(context, payloadSchedule) {
        await takeAttendanceTeacher(context.rootGetters['school/getSchoolId'], payloadSchedule.scheduleId, payloadSchedule.teacherId, context.rootGetters['auth/getToken']);
        const teacher = context.getters.getDetail.teachers.filter(teacherObj => teacherObj._id == payloadSchedule.teacherId);
        context.commit('setTeacherAttend', teacher[0]);
    },
    async loadSchedulesMainView(context, schoolId) {
        const sid = schoolId || context.rootGetters['school/getSchoolId'];
        const token = context.rootGetters['auth/getToken'];
        if (!sid) {
            context.commit('setSchedulesMainView', { todayClasses: [], thisWeekClasses: [] });
            return;
        }
        const response = await getClassesToMainView(token, sid);
        context.commit('setSchedulesMainView', response.data);
    },
    async loadMyClassesByMySubscription(context, limit) {
        const response = await getMyClassesByMySubscription(context.rootGetters['auth/getCurrentUserId'], context.rootGetters['auth/getToken'], limit);
        context.commit('setMySchedulesBySubscription', response.data);
    },
    async generateQRToken(context, payload) {
        console.log('payload', payload);
        console.log('context.rootGetters["auth/getToken"]', context.rootGetters['auth/getToken']);
        console.log('context.rootGetters["auth/getCurrentUserId"]', context.rootGetters['auth/getCurrentUserId']);



        
        const response = await generateQRToken(payload.schoolId ,payload.scheduleId, context.rootGetters['auth/getToken'], context.rootGetters['auth/getCurrentUserId']);
        return response.data.qrToken;
    },
    async scanQRToken(context, payload) {
        await scanQRToken(context.rootGetters['school/getSchoolId'], payload.scheduleId, payload.qrToken, context.rootGetters['auth/getToken']);
        // Refresh schedule detail after scanning
        await context.dispatch('getScheduleDetailById', { id: payload.scheduleId });
    },
    async updateSchedule(context, { scheduleId, changes, scope }) {
        const token = context.rootGetters['auth/getToken'];
        const schoolId = context.rootGetters['school/getSchoolId'];
        const payload = { ...changes, scope };
        const response = await updateScheduleService(token, schoolId, scheduleId, payload);
        await context.dispatch('getScheduleDetailById', { id: scheduleId });
        if (context.state.listSchedule.length > 0) {
            await context.dispatch('loadSchedule', { forceRefresh: true });
        }
        return response.data;
    }
}